window.addEventListener('load', ()=>{
  let resizeInterval = null;
  const clearResizeInterval = function() {
    clearInterval(resizeInterval);
    document.getElementById('product-block-container').classList.remove('prevent-overflow-judder');
  }
  const fireHeightResize = function() {
    document.getElementById('product-block-container').classList.add('prevent-overflow-judder');
    resizeInterval = setInterval(heightresize, 1000/60);
    setTimeout(clearResizeInterval, 1000);
  }
  const heightresize = function() {
    let info = document.getElementById('product-info-block').offsetHeight;
    let desc = document.getElementById('product-description-block').offsetHeight;
    let acco = document.getElementById('product-accordions-block').offsetHeight;
    document.getElementById('product-block-container').style = 'height: '+(info+desc+acco+500)+'px';
  }
  heightresize();
  console.log(document.getElementsByClassName('collapsible-trigger-btn--borders'))
  document.getElementsByClassName('collapsible-trigger-btn--borders').forEach((elem) => {
    elem.addEventListener('click', fireHeightResize);
  });
  window.addEventListener('resize',fireHeightResize);
});